import {AuthRepository} from '@domain/model/Auth/AuthRepository';
import {AppleToken} from '@domain/model/Auth/AppleToken';
import {AppleRepository} from '@domain/model/Apple/AppleRepository';

export interface LoginWithAppleFn {
  readonly login: (token: AppleToken) => Promise<void>;
  readonly isAppleLoginSupported: () => boolean;
  readonly getAccessToken: () => Promise<string>;
}

export const LoginWithApple = (authRepo: AuthRepository, appleRepo: AppleRepository): LoginWithAppleFn => {
  return {
    isAppleLoginSupported: (): boolean => appleRepo.isSupported(),
    login: (token: AppleToken) => authRepo.loginWithApple(token),
    getAccessToken: async () => await appleRepo.getAccessToken(),
  };
};
